import {
    FCL_IMPORT_ARRIVAL_NOTICE_REPORT_LIST,
    FCL_IMPORT_ARRIVAL_NOTICE_REPORT_SUMMARY,
    FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_LIST,
    FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_SUMMARY,
    FCL_IMPORT_BOOKING_REPORT_LIST,
    FCL_IMPORT_BOOKING_REPORT_SECTIONS,
    FCL_IMPORT_BOOKING_REPORT_SUMMARY,
    FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_LIST,
    FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_SUMMARY,
    FCL_IMPORT_CONTAINER_TRACKING_REPORT_LIST,
    FCL_IMPORT_CONTAINER_TRACKING_REPORT_PAGINATION,
    FCL_IMPORT_CONTAINER_TRACKING_REPORT_SUMMARY,
    FCL_IMPORT_ETA_STATUS_REPORT_LIST,
    FCL_IMPORT_ETA_STATUS_REPORT_SUMMARY,
    FCL_IMPORT_STATUS_AUDIT_REPORT_LIST,
    FCL_IMPORT_STATUS_AUDIT_REPORT_SUMMARY,
    FCL_IMPORT_TRUCKING_REPORT_LIST,
    FCL_IMPORT_TRUCKING_REPORT_SUMMARY,
    FCL_IMPORT_FILE_CANCELLATION_REPORT_LIST,
    FCL_IMPORT_FILE_CANCELLATION_REPORT_SUMMARY,
    FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_LIST,
    FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_SUMMARY,
    FCL_IMPORT_PROFIT_LOSS_REPORT_LIST,
    FCL_IMPORT_PROFIT_LOSS_REPORT_SUMMARY,
    FCL_IMPORT_PROFIT_LOSS_REPORT_SECTIONS,
    FCL_IMPORT_RATE_QUOTE_REPORT_LIST,
    FCL_IMPORT_RATE_QUOTE_REPORT_SUMMARY,
    FCL_IMPORT_RATE_QUOTE_REPORT_SECTIONS,
    FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_LIST,
    FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_SUMMARY,
    FCL_IMPORT_GROSS_PL_REPORT_LIST,
    FCL_IMPORT_GROSS_PL_REPORT_SUMMARY,
} from "./constant";

export const initStateFeed = {
    importBookingReportList: [],
    importBookingReportSummary: {},
    importBookingReportSections: {},
    importActiveShipmentReportList: [],
    importActiveShipmentReportSummary: {},
    importContainerDemurrageReportList: [],
    importContainerDemurrageReportSummary: {},
    importTruckingReportList: [],
    importTruckingReportSummary: {},
    importStatusAuditReportList: [],
    importStatusAuditReportSummary: {},
    importContainerTrackingReportList: [],
    importContainerTrackingReportSummary: {},
    importContainerTrackingReportPagination: {},
    importArrivalNoticeReportList: [],
    importArrivalNoticeReportSummary: {},
    importEtaStatusReportList: [],
    importEtaStatusReportSummary: {},
    importFileCancellationReportList: [],
    importFileCancellationReportSummary: {},
    importArrivalNoticePreAlertReportList: [],
    importArrivalNoticePreAlertReportSummary: {},
    importProfitLossReportList: [],
    importProfitLossReportSummary: {},
    importProfitLossReportSections: {},
    importRateQuoteReportList: [],
    importRateQuoteReportSummary: {},
    importRateQuoteReportSections: {},
    importProfitAndLossBasedOnBookingReportList: [],
    importProfitAndLossBasedOnBookingReportSummary: {},
    importGrossPLReportList: [],
    importGrossPLReportSummary: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case FCL_IMPORT_BOOKING_REPORT_LIST:
            return { ...state, importBookingReportList: action.payload };
        case FCL_IMPORT_BOOKING_REPORT_SUMMARY:
            return { ...state, importBookingReportSummary: action.payload };
        case FCL_IMPORT_BOOKING_REPORT_SECTIONS:
            return { ...state, importBookingReportSections: action.payload };
        case FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_LIST:
            return { ...state, importActiveShipmentReportList: action.payload };
        case FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_SUMMARY:
            return { ...state, importActiveShipmentReportSummary: action.payload };
        case FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_LIST:
            return { ...state, importContainerDemurrageReportList: action.payload };
        case FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_SUMMARY:
            return { ...state, importContainerDemurrageReportSummary: action.payload };
        case FCL_IMPORT_TRUCKING_REPORT_LIST:
            return { ...state, importTruckingReportList: action.payload };
        case FCL_IMPORT_TRUCKING_REPORT_SUMMARY:
            return { ...state, importTruckingReportSummary: action.payload };
        case FCL_IMPORT_STATUS_AUDIT_REPORT_LIST:
            return { ...state, importStatusAuditReportList: action.payload };
        case FCL_IMPORT_STATUS_AUDIT_REPORT_SUMMARY:
            return { ...state, importStatusAuditReportSummary: action.payload };
        case FCL_IMPORT_CONTAINER_TRACKING_REPORT_LIST:
            return { ...state, importContainerTrackingReportList: action.payload };
        case FCL_IMPORT_CONTAINER_TRACKING_REPORT_SUMMARY:
            return { ...state, importContainerTrackingReportSummary: action.payload };
        case FCL_IMPORT_CONTAINER_TRACKING_REPORT_PAGINATION:
            return { ...state, importContainerTrackingReportPagination: action.payload };
        case FCL_IMPORT_ARRIVAL_NOTICE_REPORT_LIST:
            return { ...state, importArrivalNoticeReportList: action.payload };
        case FCL_IMPORT_ARRIVAL_NOTICE_REPORT_SUMMARY:
            return { ...state, importArrivalNoticeReportSummary: action.payload };
        case FCL_IMPORT_ETA_STATUS_REPORT_LIST:
            return { ...state, importEtaStatusReportList: action.payload };
        case FCL_IMPORT_ETA_STATUS_REPORT_SUMMARY:
            return { ...state, importEtaStatusReportSummary: action.payload };
        case FCL_IMPORT_FILE_CANCELLATION_REPORT_LIST:
            return { ...state, importFileCancellationReportList: action.payload };
        case FCL_IMPORT_FILE_CANCELLATION_REPORT_SUMMARY:
            return { ...state, importFileCancellationReportSummary: action.payload };
        case FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_LIST:
            return { ...state, importArrivalNoticePreAlertReportList: action.payload };
        case FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_SUMMARY:
            return { ...state, importArrivalNoticePreAlertReportSummary: action.payload };
        case FCL_IMPORT_PROFIT_LOSS_REPORT_LIST:
            return { ...state, importProfitLossReportList: action.payload };
        case FCL_IMPORT_PROFIT_LOSS_REPORT_SUMMARY:
            return { ...state, importProfitLossReportSummary: action.payload };
        case FCL_IMPORT_PROFIT_LOSS_REPORT_SECTIONS:
            return { ...state, importProfitLossReportSections: action.payload };
        case FCL_IMPORT_RATE_QUOTE_REPORT_LIST:
            return { ...state, importRateQuoteReportList: action.payload };
        case FCL_IMPORT_RATE_QUOTE_REPORT_SUMMARY:
            return { ...state, importRateQuoteReportSummary: action.payload };
        case FCL_IMPORT_RATE_QUOTE_REPORT_SECTIONS:
            return { ...state, importRateQuoteReportSections: action.payload };
        case FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_LIST:
            return { ...state, importProfitAndLossBasedOnBookingReportList: action.payload };
        case FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_SUMMARY:
            return { ...state, importProfitAndLossBasedOnBookingReportSummary: action.payload };
        case FCL_IMPORT_GROSS_PL_REPORT_LIST:
            return { ...state, importGrossPLReportList: action.payload };
        case FCL_IMPORT_GROSS_PL_REPORT_SUMMARY:
            return { ...state, importGrossPLReportSummary: action.payload };
        default:
            return state;
    }
};
